module.exports = __webpack_public_path__ + "static/media/pledjelogo.2df7c4ee.png";